import { useEffect } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { withAuthUser } from "next-firebase-auth";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useAuth } from "@/components/auth/hooks/useAuth";
import { useTranslation } from "next-i18next";
// BOOTSTRAP
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
// COMPONENTS
import BootstrapSpinner from "@/components/elements/LoadingPlaceholders/BootstrapSpinner";
import SideLinks from "@/components/core/CustomerService/SideLinks/SideLinks";
import Banner from "@/components/core/LadingPage/Banner/Banner";
// ICONS
import { ProductTag, PackageIcon, PhoneIcon, RefreshCcwIcon } from "@/public/icons/icons";
// STYLE
import s from "./customer-service.module.scss";
import { NextSeo } from "next-seo";

const bannerColumns = [
  {
    id: 1,
    title: "discover-catalog",
  },
];
const bannerLinks = [{ id: 1, text: "browse-catalog", href: "/catalogue/ALL_PRODUCTS" }];

function RecyclingAndSustainability() {
  const auth = useAuth();
  const router = useRouter();

  const { t } = useTranslation("recycling-and-sustainability");

  // If the user is not allowed will be redirect to homepage.
  useEffect(() => {
    if (auth.isUserSupplier()) {
      router.push("/home-supplier");
    }
  }),
    [auth];

  return auth.isUserSupplier() ? (
    <BootstrapSpinner />
  ) : (
    <Container fluid className="px-0">
      <NextSeo
        title={t("recycling")}
        description={""}
        openGraph={{
          type: "website",
          title: t("recycling"),
          description: "",
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/recycling`,
        }}
      />
      <Row className="mx-0 px-3">
        <Col className={`${s.side_links}`}>
          <SideLinks />
        </Col>
        <Col className="px-0" style={{ maxWidth: "80rem" }}>
          <h1 className="fs-1 fw-semibold text-center text-md-start">{t("recycling").toUpperCase()}</h1>
          <div className="pt-5">
            <p>{t("instructions")}</p>
            <p>{t("qr-code")}</p>
            <p className="d-grid">
              <span>{t("guide")}</span>
              <span>{t("check-disposal")}</span>
            </p>
          </div>
          <div className="pt-5">
            <Table striped bordered responsive>
              <thead>
                <tr>
                  <th>{t("reference-image")}</th>
                  <th>{t("material-description")}</th>
                  <th>{t("material-type")}</th>
                  <th>{t("how-to-recycle")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="d-flex justify-content-center">
                    <div className="py-3">
                      <ProductTag width={96} height={96} color="black" />
                    </div>
                  </td>
                  <td className="align-middle text-center fw-medium">{t("paper-tag")}</td>
                  <td className="align-middle text-center fw-medium">{t("paper")}</td>
                  <td className="align-middle text-center fw-medium">{t("pap21")}</td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div style={{paddingTop: "8rem", paddingBottom: "2rem"}}>
            <Banner color="banner-green" columns={bannerColumns} links={bannerLinks} buttonVariant="outline-light" signupModal={false} t={t} />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "header",
        "footer",
        "customer-service",
        "recycling-and-sustainability",
        "services-side-links",
        "db-translations",
      ])),
    },
  };
}

export default withAuthUser({})(RecyclingAndSustainability);
